import React from "react";
import { SmCaroussel } from "../SmCaroussel";
import { CarousselCards } from "../CarousselCards";

export const SmCarousselContainer = () => {
    return(
        <>
            <SmCaroussel carousselClass="carousel-item active" >
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img1.png" 
                    alt="Miniatura imagem projeto 1"
                    dataSrc="images/galeria/img1.png" 
                    dataIndex="0"
                    classNameCol="col-12"
                    
                />
            </SmCaroussel>
            <SmCaroussel carousselClass="carousel-item" >
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img2.png" 
                    alt="Miniatura imagem projeto 2"
                    dataSrc="images/galeria/img2.png" 
                    dataIndex="1"
                    classNameCol="col-12"
                />
            </SmCaroussel>
            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img3.png" 
                    alt="Miniatura imagem projeto 3"
                    dataSrc="images/galeria/img3.png" 
                    dataIndex="2"
                    classNameCol="col-12"
                />
            </SmCaroussel>

            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img4.png" 
                    alt="Miniatura imagem projeto 4"
                    dataSrc="images/galeria/img4.png" 
                    dataIndex="3"
                    classNameCol="col-12"
                />
            </SmCaroussel>

            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img5.png" 
                    alt="Miniatura imagem projeto 5"
                    dataSrc="images/galeria/img5.png" 
                    dataIndex="4"
                    classNameCol="col-12"
                />
            </SmCaroussel>

            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img6.png" 
                    alt="Miniatura imagem projeto 6"
                    dataSrc="images/galeria/img6.png" 
                    dataIndex="5"
                    classNameCol="col-12"
                />
            </SmCaroussel>

            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img7.png" 
                    alt="Miniatura imagem projeto 7"
                    dataSrc="images/galeria/img7.png" 
                    dataIndex="6"
                    classNameCol="col-12"
                />
            </SmCaroussel>

            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img8.png" 
                    alt="Miniatura imagem projeto 8"
                    dataSrc="images/galeria/img8.png" 
                    dataIndex="7"
                    classNameCol="col-12"
                />
            </SmCaroussel>

            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img9.png" 
                    alt="Miniatura imagem projeto 9"
                    dataSrc="images/galeria/img9.png" 
                    dataIndex="8"
                    classNameCol="col-12"
                />
            </SmCaroussel>

            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img10.png" 
                    alt="Miniatura imagem projeto 10"
                    dataSrc="images/galeria/img10.png" 
                    dataIndex="9"
                    classNameCol="col-12"
                />
            </SmCaroussel>

            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img11.png" 
                    alt="Miniatura imagem projeto 11"
                    dataSrc="images/galeria/img11.png" 
                    dataIndex="10"
                    classNameCol="col-12"
                />
            </SmCaroussel>

            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img12.png" 
                    alt="Miniatura imagem projeto 12"
                    dataSrc="images/galeria/img12.png" 
                    dataIndex="11"
                    classNameCol="col-12"
                />
            </SmCaroussel>

            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img13.png" 
                    alt="Miniatura imagem projeto 13"
                    dataSrc="images/galeria/img13.png" 
                    dataIndex="12"
                    classNameCol="col-12"
                />
            </SmCaroussel>

            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img14.png" 
                    alt="Miniatura imagem projeto 14"
                    dataSrc="images/galeria/img14.png" 
                    dataIndex="13"
                    classNameCol="col-12"
                />
            </SmCaroussel>

            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img15.png" 
                    alt="Miniatura imagem projeto 15"
                    dataSrc="images/galeria/img15.png" 
                    dataIndex="14"
                    classNameCol="col-12"
                />
            </SmCaroussel>

            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img16.png" 
                    alt="Miniatura imagem projeto 16"
                    dataSrc="images/galeria/img16.png" 
                    dataIndex="15"
                    classNameCol="col-12"
                />
            </SmCaroussel>

            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img17.png" 
                    alt="Miniatura imagem projeto 17"
                    dataSrc="images/galeria/img17.png" 
                    dataIndex="16"
                    classNameCol="col-12"
                />
            </SmCaroussel>

            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img18.png" 
                    alt="Miniatura imagem projeto 18"
                    dataSrc="images/galeria/img18.png" 
                    dataIndex="17"
                    classNameCol="col-12"
                />
            </SmCaroussel>

            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img19.png" 
                    alt="Miniatura imagem projeto 19"
                    dataSrc="images/galeria/img19.png" 
                    dataIndex="18"
                    classNameCol="col-12"
                />
            </SmCaroussel>

            <SmCaroussel carousselClass="carousel-item">
                <CarousselCards 
                    src="images/galeria/miniaturas/min_img20.png" 
                    alt="Miniatura imagem projeto 20"
                    dataSrc="images/galeria/img20.png" 
                    dataIndex="19"
                    classNameCol="col-12"
                />
            </SmCaroussel>
        </>
    );
};